













































import CityService from '@/domain/states/service/city.service';
import debounce from '@/shared/utils/debounce';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Loading from '@/shared/loading/loading.component.vue';
import SelectionComponent from '@/shared/fields/selection.componet.vue';

@Component({
  components: {
    Loading,
    SelectionComponent,
  },
})
export default class CitiesFilterComponent extends Vue {
  @Prop({ type: Object, required: true })
  value!: string[]

  cities: string[] = [];

  cityNameSearchInput: string = '';

  loading: boolean = false;

  setCityNameSearchInput(value: string) {
    this.cityNameSearchInput = value;
    if (value.length > 3) {
      this.getCityContainingNameDebounce();
    }
  }

  getCityContainingNameDebounce() {
    debounce.debounce(() => this.getAllCityNames());
  }

  async getAllCityNames() {
    this.loading = true;
    CityService.getCityContainingName(this.cityNameSearchInput).then((response) => {
      const filteredCities = response.filter(city => !this.cities.includes(city));
      this.cities.push(...filteredCities);
    }).finally(() => {
      this.loading = false;
    });
  }

  get withoutCityText() {
    return this.loading ? 'Buscando...' : 'Nenhuma cidade encontrada';
  }
}
